module.exports = __webpack_public_path__ + "d38b045b8c1bf4efbc06840d0686bb58.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/ben_and_jerrys.png
// module id = 624
// module chunks = 0